import { useRef } from 'react';
import SimpleReactValidator from 'simple-react-validator';

const MessageValidator = () => {
    return useRef(new SimpleReactValidator({
        className: 'text-danger',
        validators: {
            dateFrom: {
                message: 'Date From is required.',
                rule: (val) => val !== undefined && val !== '',
                required: true
            },
            dateTo: {
                message: 'Date To is required.',
                rule: (val) => val !== undefined && val !== '',
                required: true
            },
            dateRange: {
                message: 'Date To must be after Date From.',
                rule: (val, params) => {
                    const dateFrom = params[0];
                    if (!val || !dateFrom) return true;
                    return new Date(val) > new Date(dateFrom);
                }
            },
            messageContent: {
                message: 'Message content is required.',
                rule: (val) => {
                    if (!val) return false;
                    // Remove HTML tags and trim whitespace
                    const textContent = val.replace(/<[^>]*>/g, '').trim();
                    return textContent.length > 0;
                },
                required: true
            }
        },
        messages: {
            required: 'This field is required.',
            date: 'Please enter a valid date.'
        }
    })).current;
};

export default MessageValidator; 